<template>
  <div class="text-center" :class="cssClass">
    <i class="fa fa-spin fa-spinner"></i>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: ['color', 'size'],
  computed: {
    cssClass () {
      return [
        `text-${this.color}`,
        `size-${this.size}`
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.size-big {
  font-size: $font_size_large
}
.size-regular {
  font-size: $font_size_regular;
}
.size-medium {
  font-size: $font_size_medium;
}
</style>
